const o = ({
  defaultCreatableProps: g,
  creatableProps: s
}) => {
  if (s)
    return {
      ...g,
      ...s,
      suggestionProps: {
        ...g.suggestionProps,
        ...s.suggestionProps
      }
    };
};
export {
  o as mergeCreatableProps
};
